const isBoostClaimable = (boost?: BoostTimerFragment) => {
  const { claimed, isLimitReached, isTimerOver, winAmount = 0 } = boost ?? {};
  return !claimed && winAmount > 0 && (isLimitReached || isTimerOver);
};

export default isBoostClaimable;
